import reassign from './reassign';
import add_contact from './add_contact';

export default {
  search: {
    title: 'Пошук',
    placeholder: 'Що шукати?',
  },
  resolved: {
    resolved: 'Помітити як вирішене',
    unresolved: 'зняти помітку(невирішене)',
  },
  favorite: {
    favorite: 'Додати до улюблених',
    unfavorite: 'Видалити з улюблених',
  },
  reassign,
  add_contact,
  export: {
    title: 'Исторія експорту',
  },
}
